// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// gets greatest power value of all enabled modulations
const getGreatestEnabledPower = (modulations, changedModId) => (
  modulations.reduce((a, d, i) => {
    const {
      enabled,
      power,
      radioModulationId,
    } = d

    // if this modulation is enabled and
    // it's not the modulation which is being changed
    // and it's greater than the currently stored value (a)
    if (
      enabled &&
      radioModulationId !== changedModId &&
      castToFloat(a) < castToFloat(power)
    ) {
      return power
    }

    return a
  }, null)
)

export default getGreatestEnabledPower
